/* eslint-disable no-restricted-properties */
/* eslint-disable no-unused-vars */
/* eslint-disable new-cap */
/* eslint-disable import/no-extraneous-dependencies */
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const CreatePDF = (payload) => {
  const doc = new jsPDF();

  // Garante a leitura correta tanto se passar o payload completo quanto se passar apenas o "data"
  const budgetData = payload.data ? payload.data : payload;

  // --- CONFIGURAÇÃO DE CORES DA PALETA (Identidade Visual) ---
  const PRIMARY_COLOR = [26, 54, 93]; // Azul Naval Escuro (#1A365D) - Autoridade/Profissionalismo
  const SECONDARY_COLOR = [74, 85, 104]; // Cinza Texto (#4A5568)
  const LIGHT_BG = [247, 250, 252]; // Fundo ultra-claro (#F7FAFC) para blocos
  const BORDER_COLOR = [226, 232, 240]; // Linhas sutis (#E2E8F0)

  // --- CABEÇALHO ---
  // Logo da Empresa à esquerda
  doc.addImage(budgetData.image ? budgetData.image : '/image/no-image.png', 'PNG', 14, 12, 45, 18);

  // Título e Número do Documento à direita
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(20);
  doc.setTextColor(PRIMARY_COLOR[0], PRIMARY_COLOR[1], PRIMARY_COLOR[2]);
  doc.text('ORÇAMENTO DE SERVIÇO', 200, 18, { align: 'right' });

  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(SECONDARY_COLOR[0], SECONDARY_COLOR[1], SECONDARY_COLOR[2]);
  doc.text(`Nº Registro: ${budgetData.order_number || budgetData.id || '---'}`, 200, 24, { align: 'right' });

  // --- DADOS DA EMPRESA (Alinhados à Direita e em Negrito) ---
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(PRIMARY_COLOR[0], PRIMARY_COLOR[1], PRIMARY_COLOR[2]);

  // Linha 1: Nome da Empresa - CNPJ
  const companyInfoLine1 = `${budgetData.enterprise || 'NOME DA EMPRESA'} - CNPJ: ${budgetData.document || '---'}`;
  doc.text(companyInfoLine1, 200, 30, { align: 'right' });

  // Linha 2: Telefone - E-mail
  const companyInfoLine2 = `Tel: ${budgetData.phone || '---'} - E-mail: ${budgetData.email || '---'}`;
  doc.text(companyInfoLine2, 200, 35, { align: 'right' });

  // Linha divisória horizontal
  let currentY = 40;
  doc.setDrawColor(BORDER_COLOR[0], BORDER_COLOR[1], BORDER_COLOR[2]);
  doc.setLineWidth(0.5);
  doc.line(14, currentY, 196, currentY);

  // --- SEÇÃO: INFORMAÇÕES DO CLIENTE ---
  currentY += 8;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.setTextColor(PRIMARY_COLOR[0], PRIMARY_COLOR[1], PRIMARY_COLOR[2]);
  doc.text('DADOS DO CLIENTE', 14, currentY);

  currentY += 4;
  doc.setFillColor(LIGHT_BG[0], LIGHT_BG[1], LIGHT_BG[2]);
  doc.rect(14, currentY, 182, 16, 'F');
  doc.rect(14, currentY, 182, 16, 'S');

  doc.setFontSize(10);
  doc.setTextColor(50, 50, 50);
  doc.setFont('helvetica', 'normal');
  doc.text('Cliente:', 18, currentY + 6);
  doc.setFont('helvetica', 'bold');
  doc.text(budgetData.client ? budgetData.client.name.toUpperCase() : '---', 35, currentY + 6);

  doc.setFont('helvetica', 'normal');
  doc.text('Data Entrada:', 125, currentY + 6);
  doc.setFont('helvetica', 'bold');
  const dateFormatted = budgetData.entry_date ? new Date(budgetData.entry_date).toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR');
  doc.text(dateFormatted, 153, currentY + 6);

  doc.setFont('helvetica', 'normal');
  doc.text('Contato:', 18, currentY + 12);
  doc.setFont('helvetica', 'bold');

  // Captura o telefone dinamicamente a partir do array de contatos do payload
  let clientPhone = '---';
  if (budgetData && budgetData.client) {
    if (budgetData.client.contacts && budgetData.client.contacts.length > 0 && budgetData.client.contacts[0].contact) {
      clientPhone = budgetData.client.contacts[0].contact;
    } else if (budgetData.client.phone) {
      clientPhone = budgetData.client.phone;
    }
  }
  doc.text(clientPhone, 35, currentY + 12);

  // --- SEÇÃO: DETALHES DO PRODUTO ---
  currentY += 24;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.setTextColor(PRIMARY_COLOR[0], PRIMARY_COLOR[1], PRIMARY_COLOR[2]);
  doc.text('EQUIPAMENTO / PRODUTO', 14, currentY);

  currentY += 4;
  doc.setFillColor(LIGHT_BG[0], LIGHT_BG[1], LIGHT_BG[2]);
  doc.rect(14, currentY, 182, 16, 'F');
  doc.rect(14, currentY, 182, 16, 'S');

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(50, 50, 50);
  doc.text('Nome:', 18, currentY + 6);
  doc.setFont('helvetica', 'bold');
  doc.text(budgetData.product ? budgetData.product.name.toUpperCase() : '---', 32, currentY + 6);

  doc.setFont('helvetica', 'normal');
  doc.text('Marca:', 18, currentY + 11);
  doc.setFont('helvetica', 'bold');
  doc.text(budgetData.product ? budgetData.product.brand.toUpperCase() : '---', 32, currentY + 11);

  doc.setFont('helvetica', 'normal');
  doc.text('Modelo:', 110, currentY + 11);
  doc.setFont('helvetica', 'bold');
  doc.text(budgetData.product ? budgetData.product.model.toUpperCase() : '---', 126, currentY + 11);

  // --- SEÇÃO: MOTIVO DA MANUTENÇÃO (OBSERVAÇÃO) ---
  currentY += 24;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.setTextColor(PRIMARY_COLOR[0], PRIMARY_COLOR[1], PRIMARY_COLOR[2]);
  doc.text('MOTIVO DA MANUTENÇÃO / OBSERVAÇÕES', 14, currentY);

  currentY += 4;
  const observationText = budgetData.observation || 'Nenhuma observação ou defeito relatado registrado.';
  const splitMemo = doc.splitTextToSize(observationText, 174);
  const memoHeight = (splitMemo.length * 5) + 6;

  doc.setFillColor(LIGHT_BG[0], LIGHT_BG[1], LIGHT_BG[2]);
  doc.rect(14, currentY, 182, Math.max(12, memoHeight), 'F');
  doc.rect(14, currentY, 182, Math.max(12, memoHeight), 'S');

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(SECONDARY_COLOR[0], SECONDARY_COLOR[1], SECONDARY_COLOR[2]);
  doc.text(splitMemo, 18, currentY + 6);

  currentY += Math.max(12, memoHeight) + 8;

  // --- SEÇÃO: DIAGNÓSTICO ---
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.setTextColor(PRIMARY_COLOR[0], PRIMARY_COLOR[1], PRIMARY_COLOR[2]);
  doc.text('DIAGNÓSTICO TÉCNICO', 14, currentY);

  currentY += 4;
  const diagnosisText = budgetData.diagnosis || 'Nenhum diagnóstico técnico registrado até o momento.';
  const splitDiagnosis = doc.splitTextToSize(diagnosisText, 174);
  const diagnosisHeight = (splitDiagnosis.length * 5) + 6;

  doc.setFillColor(LIGHT_BG[0], LIGHT_BG[1], LIGHT_BG[2]);
  doc.rect(14, currentY, 182, Math.max(12, diagnosisHeight), 'F');
  doc.rect(14, currentY, 182, Math.max(12, diagnosisHeight), 'S');

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(SECONDARY_COLOR[0], SECONDARY_COLOR[1], SECONDARY_COLOR[2]);
  doc.text(splitDiagnosis, 18, currentY + 6);

  currentY += Math.max(12, diagnosisHeight) + 8;

  // --- TABELA DE SERVIÇOS E CÁLCULO FINANCEIRO DINÂMICO ---
  const tableRows = [];
  let itemCounter = 1;
  let totalApprovedAndExecutedServices = 0; // Guardará o somatório correto apenas dos executados

  if (budgetData.services && budgetData.services.length > 0) {
    budgetData.services.forEach((item) => {
      // Regra base: Passa apenas o que foi aprovado pelo cliente ('A')
      if (item.client_status === 'A') {
        const isNotExecuted = item.status === 'N';
        const serviceValue = parseFloat(item.value) || 0;

        // Regra de Negócio: Somente soma se NÃO for status 'N' (Não Realizado)
        if (!isNotExecuted) {
          totalApprovedAndExecutedServices += serviceValue;
        }

        tableRows.push([
          String(itemCounter),
          item.service || item.name || 'Serviço executado',
          item.client_status_details || 'Aprovado',
          isNotExecuted ? 'Não Realizado' : (item.status_details || 'Executado'),
          `R$ ${serviceValue.toFixed(2).replace('.', ',')}`
        ]);
        itemCounter += 1;
      }
    });
  }

  // Se nenhum serviço passou pelo filtro ou o array estiver vazio
  if (tableRows.length === 0) {
    tableRows.push(['-', 'Nenhum serviço aprovado atrelado a esta ordem.', '-', '-', '-']);
  }

  doc.autoTable({
    startY: currentY,
    head: [['Item', 'Descrição do Serviço', 'Aprovação', 'Executado', 'Preço']],
    body: tableRows,
    theme: 'striped',
    headStyles: {
      fillColor: PRIMARY_COLOR,
      textColor: [255, 255, 255],
      fontStyle: 'bold',
      fontSize: 10,
      halign: 'left'
    },
    columnStyles: {
      0: { cellWidth: 20, halign: 'center' },
      2: { cellWidth: 28, halign: 'center' },
      3: { cellWidth: 32, halign: 'center' },
      4: { cellWidth: 30, halign: 'right' }
    },
    styles: {
      font: 'helvetica',
      fontSize: 9,
      cellPadding: 4
    },
    didDrawPage: (data) => {
      currentY = data.cursor.y;
    }
  });

  // --- PROCESSAMENTO E FORMATÇÃO DE VALORES DO RODAPÉ ---
  // Converte a Mão de Obra vinda como String com vírgula para Float tratável
  const laborValue = parseFloat(String(budgetData.labor).replace(',', '.')) || 0;

  // O Valor Total Dinâmico é a Mão de Obra + os Serviços Aprovados Realizados
  const finalOrderTotal = laborValue + totalApprovedAndExecutedServices;

  // --- SEÇÃO TOTALIZADORES FINANCEIROS ---
  currentY += 10;

  if (currentY > 230) {
    doc.addPage();
    currentY = 20;
  }

  doc.setLineWidth(0.5);
  doc.setDrawColor(BORDER_COLOR[0], BORDER_COLOR[1], BORDER_COLOR[2]);
  doc.line(110, currentY, 196, currentY);

  currentY += 6;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.setTextColor(SECONDARY_COLOR[0], SECONDARY_COLOR[1], SECONDARY_COLOR[2]);
  doc.text('Mão de Obra:', 110, currentY);
  doc.text(`R$ ${laborValue.toFixed(2).replace('.', ',')}`, 196, currentY, { align: 'right' });

  currentY += 6;
  doc.text('Serviços Aprovados:', 110, currentY);
  doc.text(`R$ ${totalApprovedAndExecutedServices.toFixed(2).replace('.', ',')}`, 196, currentY, { align: 'right' });

  currentY += 8;
  doc.setFillColor(PRIMARY_COLOR[0], PRIMARY_COLOR[1], PRIMARY_COLOR[2]);
  doc.rect(110, currentY - 5, 86, 9, 'F');

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.setTextColor(255, 255, 255);
  doc.text('VALOR TOTAL:', 114, currentY + 1);
  doc.text(`R$ ${finalOrderTotal.toFixed(2).replace('.', ',')}`, 192, currentY + 1, { align: 'right' });

  // --- ESPAÇO PARA ASSINATURAS ---
  const pageHeight = doc.internal.pageSize.height;
  doc.setDrawColor(BORDER_COLOR[0], BORDER_COLOR[1], BORDER_COLOR[2]);
  doc.line(14, pageHeight - 45, 196, pageHeight - 45);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(SECONDARY_COLOR[0], SECONDARY_COLOR[1], SECONDARY_COLOR[2]);

  doc.line(14, pageHeight - 25, 95, pageHeight - 25);
  doc.text('Assinatura da Empresa', 14, pageHeight - 20);

  doc.line(115, pageHeight - 25, 196, pageHeight - 25);
  doc.text('Assinatura do Cliente', 115, pageHeight - 20);

  // --- DATAS E PAGINAÇÃO ---
  doc.setFontSize(8);
  doc.setTextColor(160, 174, 192);
  const dateGenerate = `Gerado em: ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')}`;
  doc.text(dateGenerate, 14, pageHeight - 8);

  const totalPages = doc.internal.getNumberOfPages();
  doc.text(`Página 1 de ${totalPages}`, 200, pageHeight - 8, { align: 'right' });

  doc.save(`Orcamento_${budgetData.order_number || budgetData.id || 'Sem_Numero'}.pdf`);
};

export default CreatePDF;
